<template>
  <div>
    <div class="shuoming-text" v-html="patentData.detail.instrPath"></div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      patentData: null
    }
  },
  created() {

  },
  mounted() {
    this.patentData = this.data;
  },
  methods: {

  }
}
</script>

<style>
.shuoming-text {
  width: 100%;
  height: auto;
  font-size: 12px;
}
</style>